import * as React from 'react';
import * as styles from './style.css';

export interface IFinanceMainPageProps {
  imageUrl: string;
  reference: string;
}

export class FinanceMainPage extends React.Component<IFinanceMainPageProps, {}> {
  public render() {
    return (
      <a target="_blank" className={styles['banner']} href={this.props.reference}>
        <img className={styles['banner-image']} src={this.props.imageUrl} />
      </a>
    );
  }
}
